import { useId, useState } from 'react'

export function PasswordField({ label, autoComplete, value, onChange, error, hint, minLength = 10 }: {
  label: string
  autoComplete: string
  value: string
  onChange: (value: string) => void
  error?: string
  hint?: string
  minLength?: number
}) {
  const id = useId()
  const errorId = `${id}-error`
  const hintId = `${id}-hint`
  const [visible, setVisible] = useState(false)

  return <div className="form-field">
    <label htmlFor={id}>{label}</label>
    <div className="password-control">
      <input id={id} type={visible ? 'text' : 'password'} autoComplete={autoComplete} minLength={minLength}
        value={value} onChange={(event) => onChange(event.target.value)} aria-invalid={Boolean(error)}
        aria-describedby={[hint ? hintId : '', error ? errorId : ''].filter(Boolean).join(' ') || undefined} />
      <button type="button" className="password-toggle" onClick={() => setVisible((current) => !current)} aria-pressed={visible}>
        {visible ? 'Ocultar' : 'Mostrar'}
      </button>
    </div>
    {hint && <p id={hintId} className="field-hint">{hint}</p>}
    {error && <p id={errorId} className="field-error" role="alert">{error}</p>}
  </div>
}
